export { default } from './components/Icon';


//////////////////
// WEBPACK FOOTER
// ../~/@ant-design/icons-react/es/index.js
// module id = 491
// module chunks = 1